let taskSyncPromise = null

/** 登录后同步匿名访客与登录用户的任务（GET task_sync：video + comprehensive） */
export async function syncUserVideoTasks() {
  if (!import.meta.client) return null

  const userStore = useUserStore()
  const token = userStore.token || localStorage.getItem('token') || ''
  if (!token) return null

  if (taskSyncPromise) return taskSyncPromise

  taskSyncPromise = (async () => {
    const [{ ensureGuestIdentity }, { syncUserVideoTasks: syncUserVideoTasksApi }] =
      await Promise.all([
        import('~/utils/requestVerification.js'),
        import('~/composables/api/user.js'),
      ])
    const uuid = ensureGuestIdentity()
    if (!uuid) return null
    const [videoRes, comprehensiveRes] = await Promise.all([
      syncUserVideoTasksApi('video'),
      syncUserVideoTasksApi('comprehensive'),
    ])
    return { video: videoRes, comprehensive: comprehensiveRes }
  })().finally(() => {
    taskSyncPromise = null
  })

  return taskSyncPromise
}
